import React from "react";
import PropTypes from "prop-types";
import { Spinner, Isvg } from "../../../components";
import {
  BookStore,
  NavigatorAction,
  NavigatorStore,
  Dispatcher
} from "../../../flux";

import Reading from "./reading";
import ToolButton from "./tool-button";

export default class AssignmentNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      book: {},
      startPos: 0,
      currentPage: 0,
      movingReadingId: null,
      overReadingId: null
    };
    this.contentsRoute = "contents-selection";
    this.startEndRoute = "start-end";
    this.pageRangeRoute = "page-range";
    this.easyTocRoute = 'easy-toc';
  }

  componentWillUnmount() {
    Dispatcher.unbind(Dispatcher.BOOK_CHANGE, "assignmentnew-bookchange");
  }

  componentDidMount() {
    const lastRoute = NavigatorStore.get();
    this.loadBook();
    const assignment = this.props.assignment;
    if (assignment.uuid) {
      let url = `/books/${assignment.vbid}/assignment/${assignment.uuid}/edit`;
      Fraction.Router.setRoute(url);
    }
    Dispatcher.bind(
      Dispatcher.BOOK_CHANGE,
      () => {
        this.loadBook();
      },
      "assignmentnew-bookchange"
    );
    Dispatcher.bindOnce(Dispatcher.BOOK_PAGE_LOAD, () => {
      setTimeout(() => {
        this.focusMount.focus();
      }, 0);
    });
  }

  loadBook() {
    const book = BookStore.get(this.props.isbn);
    this.setState({ book }, () => {
      if (!this.focused) {
        this.focusMount.focus();
        this.focused = true;
      }
    });
  }

  _createOrUpdateAssignment() {
    if (!this.props.saving) {
      this.props.createOrUpdateAssignment();
      NavigatorAction.push("success");
    }
  }

  handleDragStart(id) {
    this.setState({ movingReadingId: id });
  }

  handleDragOver(event, id) {
    if (event.preventDefault) {
      event.preventDefault();
    }
    if (this.state.overReadingId !== id) {
      this.setState({ overReadingId: id });
    }
  }

  handleDrop(event, id) {
    if (event.stopPropagation) {
      event.stopPropagation();
    }
    if (this.state.movingReadingId && id) {
      this.props.swapReadings(this.state.movingReadingId, id);
    }
  }

  handleDragEnd(event, id) {
    this.setState({
      movingReadingId: null,
      overReadingId: null
    });
  }

  renderForm() {
    return (
      <div className="assignment-form">
        <div className="input-container">
          <label htmlFor="assignment-title">
            {i18n.t("assignments.assignment-name")}
          </label>
          <input
            type="text"
            id="assignment-title"
            name="assignment-title"
            className="input"
            placeholder={i18n.t("assignments.title-placeholder")}
            value={this.props.assignment.title || ""}
            onChange={event =>
              this.props.onTextChange({ title: event.target.value })
            }
          />
        </div>
      </div>
    );
  }

  renderReadingTools() {
    const book = BookStore.get(this.props.isbn);
    const tocAvailable = book.hasPageBreaks && !book.pagebreaksLoading && !book.tocLoading;

    return (
      <div className="reading-tools">
        <ul>
          <ToolButton
            available={tocAvailable}
            hoverMessage={i18n.t("assignments.contents-hover")}
            img="assignments_contents.svg"
            location="left"
            route={this.contentsRoute}
            text={i18n.t("assignments.contents")}
            unavailableMessage={i18n.t("assignments.contents-unavailable")}
          />
          <ToolButton
            available={tocAvailable}
            hoverMessage={i18n.t("assignments.easy-toc-hover")}
            img="assignments_easy_toc.svg"
            location="center"
            route={this.easyTocRoute}
            text={i18n.t("assignments.easy-toc")}
            unavailableMessage={i18n.t("assignments.contents-unavailable")}
          />
          <ToolButton
            available={book.vbkType && book.vbkType !== "pbk"}
            hoverMessage={i18n.t("assignments.start-end-hover")}
            img="assignments_start_end.svg"
            location="center"
            route={this.startEndRoute}
            text={i18n.t("assignments.start-end")}
            unavailableMessage={i18n.t("assignments.start-end-unavailable")}
          />
          <ToolButton
            available={book.hasPageBreaks && !this.props.pagebreaksLoading}
            hoverMessage={i18n.t("assignments.page-range-hover")}
            img="assignments_page_range.svg"
            location="right"
            route={this.pageRangeRoute}
            text={i18n.t("assignments.page-range")}
            unavailableMessage={i18n.t("assignments.page-range-unavailable")}
          />
        </ul>
      </div>
    );
  }

  renderReading(reading) {
    return (
      <Reading
        handleDragStart={this.handleDragStart}
        handleDragEnd={this.handleDragEnd}
        handleDragOver={this.handleDragOver}
        handleDrop={this.handleDrop}
        reading={reading}
        removeReading={this.props.removeReading}
        overReadingId={this.state.overReadingId}
        movingReadingId={this.state.movingReadingId}
      />
    );
  }

  renderReadings() {
    if (this.props.readings.length) {
      return (
        <div className="new-reading-list">
          <h3 id="readings" tabIndex={-1}>
            {i18n.t("assignments.readings")}:
          </h3>
          <ol>{this.props.readings.map(this.renderReading.bind(this))}</ol>
        </div>
      );
    }
  }

  render() {
    const book = this.state.book;
    if (book && this.props.feenyReady) {
      return (
        <div>
          <div id="assignment-new">
            <div className="book">
              <h2
                className="book-title"
                ref={title => {
                  this.focusMount = title;
                }}
                tabIndex={-1}
              >
                {book.title}
              </h2>
              <div className="book-author">{book.author}</div>
            </div>
            {this.renderForm()}
            <hr />
            <div className="tools-description">
              <h3 id="add-readings" tabIndex={-1}>
                {i18n.t("assignments.add-reading-message-v2")}
              </h3>
              <div aria-hidden={true}>
                {i18n.t("assignments.add-reading-hover")}
              </div>
            </div>
            {this.renderReadingTools()}
            {this.renderReadings()}
          </div>
          <div className="footer noselect">
            {this.props.saving && <span>{i18n.t("base.saving")}...</span>}
            {this.props.assignment.title && (
              <button
                className="right-button noButton"
                disabled={this.props.saving}
                onClick={this._createOrUpdateAssignment.bind(this)}
              >
                {i18n.t("base.done")}
              </button>
            )}
          </div>
        </div>
      );
    }
    return <Spinner />;
  }
}

AssignmentNew.propTypes = {
  location: PropTypes.oneOf(["left", "center", "right"]),
  isbn: PropTypes.string.isRequired,
  saving: PropTypes.bool.isRequired,
  readings: PropTypes.array,
  assignment: PropTypes.object
};
